import styles from 'styles/ImageWrapper.module.css'

const Wrapper = ({ children, ...rest }) => (
    <div className={styles.wrapper} {...rest}>
        {children}
    </div>
)

export default Wrapper